import axios from "axios";

import { DEFAULT_URL } from "./constants";

const fetch = ({ searchValue, page, type, year }) =>
  axios.get(DEFAULT_URL, {
    params: {
      apikey: process.env.REACT_APP_OMDB_API_KEY,
      s: searchValue,
      page,
      type,
      y: year,
    },
  });

const show = imdbId =>
  axios.get(DEFAULT_URL, {
    params: {
      apikey: process.env.REACT_APP_OMDB_API_KEY,
      i: imdbId,
    },
  });
const movieListApis = { fetch, show };

export default movieListApis;
